import {objectById, taskNameWithOptionalRepeatCountSuffix, urlEncode} from 'src/utilities/utils'
import search from './search'
import edit from './edit'
import templates from './templates'
import names from './names'
import myTasks from './myTasks'
import {ptracGet, ptracGetEntities, ptracGetEntity} from 'src/utilities/ptracApi'
import {OK} from 'http-status-codes'
import {make} from 'vuex-pathify'
import _ from 'lodash'

let state = {
  byJobId: [],
  reInspectionTask: null
}

const getters = make.getters(state)

getters.tasksInJobForSelect = (state) => {
  const kvps = []
  state.byJobId.forEach((task) => {
    const kvp = {
      label: taskNameWithOptionalRepeatCountSuffix(task),
      value: task.id
    }

    kvps.push(kvp)
  })

  return kvps
}

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchByPriceRuleFieldValuesStatus({}, payload) {
      return await ptracGetEntities(
        'tasks/search/findByNameAndStatusAndFieldKeyAndValue' +
        '?name=' + urlEncode(payload.name) +
        '&status=' + payload.status +
        '&key=' + payload.key +
        '&value=' + payload.value,
        'ptracTasks')
    },
    async fetchExistsByNameId({}, nameId) {
      return await ptracGet('tasks/search/existsByNameId?nameId=' + nameId)
    },
    async fetchExistsByTemplateId({}, templateId) {
      return await ptracGetEntities('tasks/search/existsByTemplateId?templateId=' + templateId)
    },
    async fetchTasksByJobId({state}, jobId) {
      const response = await ptracGetEntities('tasks/search/findByJobIdOrderByCreatedAtDesc?jobId=' + jobId, 'ptracTasks')
      if (OK === response.status) {
        state.byJobId = response.data

        const uniqueTemplateIds = _.uniq(_.map(state.byJobId, 'templateId'))
        const ttResponse = await ptracGetEntities(`task-templates/search/findByIdIn?ids=${uniqueTemplateIds.join(',')}`, 'taskTemplates')

        if (OK === ttResponse.status) {
          for (const task of state.byJobId) {
            const taskTemplate = objectById(ttResponse.data, task.templateId)
            if (taskTemplate) {
              task.template = taskTemplate
            }
          }
        }
      }
      return response
    },
    async fetchReInspectionTask({state}, payload) {
      const response = await ptracGetEntity('tasks/findMatchingReInspectionTask?departmentId=' + payload.departmentId
        + '&projectId=' + payload.projectId
        + '&jobName=' + payload.jobName)

      if (OK === response.status) {
        state.reInspectionTask = response.data
      }

      return response
    }
  },
  modules: {
    search,
    edit,
    templates,
    names,
    myTasks
  }
}
